import { defaultParamsSerializer, handleApiResponse } from '@/functions';
import { useInvalidateQueries } from '@/hooks';
import { apiClient } from '@/components/api';
import { useQuery } from '@tanstack/react-query';
import type { IPromotion } from '@/interfaces';
import type { Paginated } from '@/lib/interface';
import { PromotionProductEnum, PromotionStatusEnum } from '@/enums';
import routes from '@/lib/routes';

export type TGetPromotionsParams = {
	products?: PromotionProductEnum[];
	status?: PromotionStatusEnum[];
	periodFrom?: string;
	periodTo?: string;
	page?: number | string;
	limit?: number | string;
};

export const useRequestGetPromotions = (params?: TGetPromotionsParams, run = true) => {
	const { invalidate } = useInvalidateQueries();

	const { isFetching, data, error } = useQuery({
		queryKey: [routes.api.promotions.base, params, run],
		queryFn: () =>
			!run
				? Promise.resolve(null)
				: apiClient
						.get<Paginated<IPromotion>>(routes.api.promotions.base, params, {
							paramsSerializer: defaultParamsSerializer,
						})
						.then(handleApiResponse),
	});

	const refresh = () => invalidate(routes.api.promotions.base);

	return {
		data: data as Paginated<IPromotion>,
		promotions: (data?.data ?? []) as IPromotion[],
		isLoading: isFetching && !data,
		isFetching,
		refresh,
		error,
	};
};
